module.exports = __webpack_public_path__ + "static/media/text.2b89c5fa.png";